<template>
  <div>
    <div id="chartdiv" ref="chartElement"></div>

    <div id="list">
      <b-table
        :data="tableData"
        :paginated="isPaginated"
        :per-page="perPage"
        :current-page.sync="currentPage"
        :pagination-simple="isPaginationSimple"
        :pagination-position="paginationPosition"
        :default-sort-direction="defaultSortDirection"
        default-sort="testSum"
        :pagination-rounded="isPaginationRounded"
        :sort-icon="sortIcon"
        :sort-icon-size="sortIconSize"
        :debounce-search="1000"
        :bordered="isBordered"
        :striped="isStriped"
        :narrowed="isNarrowed"
        :hoverable="isHoverable"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
      >
        <template v-for="column in columns">
          <b-table-column
            :key="column.cityName"
            v-bind="column"
            :centered="true"
          >
            <template
              v-if="column.searchable && !column.numeric"
              #searchable="props"
            >
              <b-input
                :expanded="true"
                v-model="props.filters[props.column.field]"
                placeholder="Search..."
                size="is-small"
                class="search-input"
              />
            </template>

            <template v-slot="props">
              {{ props.row[column.field] }}
            </template>
          </b-table-column>
        </template>
      </b-table>
    </div>
  </div>
</template>

<!-- Chart code -->
<script>
/* eslint-disable */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4maps from "@amcharts/amcharts4/maps";
// Napi esetek összesen az összes településen
import pte_total_timeline from "../../assets/data/total_timeline.json";
// Napra lebontva minden településen az aznapi számok
import pte_city_timeline from "../../assets/data/city_timeline.json";
// Minden település összes esete
import pte_totalData_city from "../../assets/data/totalDataPerCityjson.json";
import pte_totalData_city_new from "../../assets/data/totalDataPerCityjson_new.json";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";


// totalDatacity összefésülése
for(let i = 0; i < pte_totalData_city.length; i++){
  for(let j = 0; j < pte_totalData_city_new.length; j++){
    if(pte_totalData_city[i].cityName == pte_totalData_city_new[j].cityName){
      pte_totalData_city[i].testSum += pte_totalData_city_new[j].testSum;
      pte_totalData_city[i].noSymptonPositive += pte_totalData_city_new[j].noSymptonPositive;
      pte_totalData_city[i].hasSymptonPositive += pte_totalData_city_new[j].hasSymptonPositive;
      pte_totalData_city[i].totalPositive += pte_totalData_city_new[j].totalPositive;
    }
  }
}

//régi 101 új 409 nap
var total_timeline_sum = new Array(409);

total_timeline_sum[0] = pte_total_timeline[0];

//Végig megy az összes napon
//Létre hoz egy objektumot ami az aznapi adat + az összes előző napi adat
for (let i = 1; i < pte_total_timeline.length; i++) {
  let tmpObj = {
    testSum: 0,
    noSymptonPositive: 0,
    hasSymptonPositive: 0,
    averageCp: 0.0,
    averageAge: 0.0,
    testWithCp: 0,
    date: ""
  };
  total_timeline_sum[i] = tmpObj;
  total_timeline_sum[i].date = pte_total_timeline[i].date;
  total_timeline_sum[i].testWithCp =
    total_timeline_sum[i - 1].testWithCp + pte_total_timeline[i].testWithCp;
  total_timeline_sum[i].averageCp = pte_total_timeline[i].averageCp;
  total_timeline_sum[i].averageAge = pte_total_timeline[i].averageAge;
  total_timeline_sum[i].testSum =
    total_timeline_sum[i - 1].testSum + pte_total_timeline[i].testSum;
  total_timeline_sum[i].noSymptonPositive =
    total_timeline_sum[i - 1].noSymptonPositive +
    pte_total_timeline[i].noSymptonPositive;
  total_timeline_sum[i].hasSymptonPositive =
    total_timeline_sum[i - 1].hasSymptonPositive +
    pte_total_timeline[i].hasSymptonPositive;
}

//Városok neveinek kiszedése, később kulcsként lesznek felhasználva
var cityKeyObj = {};
for (let i = 0; i < pte_city_timeline[0].list.length; i++) {
  let cityName = pte_city_timeline[0].list[i].cityName;
  cityKeyObj[cityName] = i;
}


for (let i = 1; i < pte_city_timeline.length; i++) {
  for (let j = 0; j < pte_city_timeline[i].list.length; j++) {
    try {

      let indexOfPrevDay = 0;
      for(let k = 0; k < pte_city_timeline[i - 1].list.length; k++){
        if(pte_city_timeline[i - 1].list[k].cityName == pte_city_timeline[i].list[j].cityName){
          indexOfPrevDay = k;
        }
      }

      let dailyMinusPositive =
        pte_city_timeline[i - 1].list[indexOfPrevDay].hasSymptonPositive +
        pte_city_timeline[i - 1].list[indexOfPrevDay].noSymptonPositive;
      let dailyPositive =
        pte_city_timeline[i].list[j].hasSymptonPositive +
        pte_city_timeline[i].list[j].noSymptonPositive;

      let dailyMinusHasCp = pte_city_timeline[i - 1].list[indexOfPrevDay].hasCp;
      let dailyHasCp = pte_city_timeline[i].list[j].hasCp;

      pte_city_timeline[i].list[j].testSum =
        pte_city_timeline[i - 1].list[indexOfPrevDay].testSum +
        pte_city_timeline[i].list[j].testSum;
      pte_city_timeline[i].list[j].noSymptonPositive =
        pte_city_timeline[i - 1].list[indexOfPrevDay].noSymptonPositive +
        pte_city_timeline[i].list[j].noSymptonPositive;
      pte_city_timeline[i].list[j].hasSymptonPositive =
        pte_city_timeline[i - 1].list[indexOfPrevDay].hasSymptonPositive +
        pte_city_timeline[i].list[j].hasSymptonPositive;

      pte_city_timeline[i].list[j].averageCp =
        (pte_city_timeline[i - 1].list[indexOfPrevDay].averageCp * dailyMinusHasCp +
          pte_city_timeline[i].list[j].averageCp * dailyHasCp) /
        (dailyMinusHasCp + dailyHasCp);

      if (dailyMinusHasCp + dailyHasCp === 0) {
        pte_city_timeline[i].list[j].averageCp = 0;
      }

      pte_city_timeline[i].list[j].averageAge =
        (pte_city_timeline[i - 1].list[indexOfPrevDay].averageAge * dailyMinusPositive +
          pte_city_timeline[i].list[j].averageAge * dailyPositive) /
        (dailyMinusPositive + dailyPositive);
      if (dailyMinusPositive + dailyPositive === 0) {
        pte_city_timeline[i].list[j].averageAge = 0;
      }

      pte_city_timeline[i].list[j].averageAge = pte_city_timeline[i].list[
        j
      ].averageAge.toFixed(1);

      pte_city_timeline[i].list[j].hasCp =
        pte_city_timeline[i - 1].list[indexOfPrevDay].hasCp +
        pte_city_timeline[i].list[j].hasCp;
    } catch (e) {}
  }
}


var populations = {
  Szárász: "40",
  Libickozma: "43",
  Rinyaújnép: "49",
  Tengeri: "53",
  Hosszúvíz: "53",
  Patca: "57",
  Murga: "58",
  Horváthertelend: "61",
  Kára: "61",
  Kemse: "63",
  Markóc: "63",
  Husztót: "68",
  Szörény: "73",
  Okorvölgy: "78",
  Almáskeresztúr: "79",
  Marócsa: "81",
  Főnyed: "83",
  Kisbeszterce: "84",
  Porrogszentpál: "84",
  Drávapiski: "86",
  Varga: "87",
  Somogybükkösd: "87",
  Kovácsszénája: "89",
  Magyarlukafa: "90",
  Dinnyeberki: "92",
  Kaposgyarmat: "92",
  Bürüs: "94",
  Erdősmárok: "94",
  Gadács: "99",
  Kaszó: "99",
  Szorosad: "99",
  Csebény: "101",
  Tarrós: "102",
  Somogysimonyi: "102",
  Palé: "104",
  Pécsbagota: "104",
  Babarcszőlős: "107",
  Kisbudmér: "112",
  Szentkatalin: "112",
  Meződ: "118",
  Pécsdevecser: "118",
  Kisdér: "119",
  Ivánbattyán: "121",
  Besence: "122",
  Szágy: "124",
  Sárok: "125",
  Nemeskisfalud: "128",
  Kisjakabfalva: "129",
  Várad: "129",
  Felsőegerszeg: "130",
  Tófű: "130",
  Szentborbás: "130",
  Fiad: "131",
  Vázsnok: "132",
  Apátvarasd: "133",
  Drávakeresztúr: "134",
  Kistamási: "134",
  Szőke: "135",
  Nagycsány: "136",
  Udvar: "136",
  Velény: "138",
  Baranyaszentgyörgy: "139",
  Tikos: "141",
  Szellő: "142",
  Csarnóta: "143",
  Sérsekszőlős: "143",
  Tótszentgyörgy: "144",
  Bosta: "145",
  Szilvás: "148",
  Vékény: "148",
  Drávagárdony: "150",
  Óbánya: "152",
  Somogydöröcske: "152",
  Kalaznó: "152",
  Gyöngyfa: "153",
  Hegyhátmaróc: "154",
  Varászló: "155",
  Ózdfalu: "156",
  Vejti: "157",
  Somogycsicsó: "157",
  Pettend: "158",
  Lápafő: "158",
  Páprád: "159",
  Nagyvejke: "159",
  Várong: "159",
  Pereked: "161",
  Katádfa: "164",
  Siklósbodony: "165",
  Nagybudmér: "167",
  Péterhida: "168",
  Regenye: "170",
  Grábóc: "171",
  Molvány: "172",
  Rinyakovácsi: "172",
  Csonkamindszent: "173",
  Okorág: "173",
  Sósvertike: "173",
  Somogyaracs: "173",
  Pócsa: "176",
  Monyoród: "177",
  Csurgónagymarton: "179",
  Lapáncsa: "181",
  Drávaszerdahely: "182",
  Kékesd: "182",
  Kisnyárád: "183",
  Komlósd: "183",
  Somogyacsa: "185",
  Kisasszond: "187",
  Ág: "188",
  Drávacsehi: "189",
  Maráza: "191",
  Bakháza: "191",
  Kisberény: "192",
  Somogyegres: "192",
  Áta: "194",
  Drávaiványi: "194",
  Bánfa: "196",
  Visz: "198",
  Baranyahídvég: "199",
  Rinyabesenyő: "200",
  Ipacsfa: "201",
  Kistapolca: "201",
  Edde: "202",
  Potony: "202",
  Sámod: "203",
  Adorjás: "205",
  Fazekasboda: "206",
  Keszőhidegkút: "206",
  Szilvásszentmárton: "207",
  Magyartelek: "208",
  Porrog: "209",
  Kákics: "210",
  Cserénfa: "210",
  Tésenfa: "211",
  Basal: "212",
  Drávacsepely: "213",
  Kisasszonyfa: "213",
  Márfa: "213",
  Rádfalva: "213",
  Kishajmás: "214",
  Feked: "215",
  Kisherend: "215",
  Liptód: "217",
  Vásárosbéc: "218",
  Peterd: "221",
  Szegerdő: "221",
  Lulla: "223",
  Kórós: "224",
  Köblény: "224",
  Miklósi: "224",
  Ecseny: "226",
  Kastélyosdombó: "227",
  Kisgyalán: "229",
  Nemeske: "230",
  Teleki: "232",
  Cún: "233",
  Ibafa: "233",
  Bisse: "234",
  Zselickisfalud: "234",
  Dúzs: "234",
  Martonfa: "235",
  Ellend: "236",
  Szaporca: "236",
  Bezedek: "238",
  Lúzsok: "238",
  Bodolyabér: "241",
  Hajmás: "242",
  Szakadát: "243",
  Gálosfa: "245",
  Ivándárda: "247",
  Tékes: "247",
  Zala: "247",
  Visnye: "248",
  Jágónak: "250",
  Somogyviszló: "251",
  Zaláta: "251",
  Szulimán: "253",
  Kiskassa: "254",
  Piskó: "256",
  Tótújfalu: "256",
  Bonnya: "257",
  Torvaj: "257",
  Kisdobsza: "258",
  Nyugotszenterzsébet: "258",
  Patosfa: "258",
  Lothárd: "260",
  Hollád: "260",
  Illocska: "261",
  Gerényes: "263",
  Bogdása: "264",
  Villánykövesd: "264",
  Újvárfalva: "264",
  Szűr: "265",
  Szőkedencs: "266",
  Alsóbogát: "267",
  Túrony: "268",
  Szárazd: "268",
  Csombárd: "269",
  Polány: "270",
  Hirics: "271",
  Szilágy: "271",
  Drávapalkonya: "272",
  Heresznye: "272",
  Kisszentmárton: "275",
  Kovácshida: "277",
  Palkonya: "281",
  Miszla: "282",
  Kacsóta: "283",
  Mekényes: "283",
  Porrogszentkirály: "283",
  Merenye: "286",
  Tormás: "291",
  Újireg: "294",
  Magyarsarlós: "296",
  Gordisa: "297",
  Závod: "299",
  Kislippó: "300",
  Zók: "300",
  Kátoly: "301",
  Garé: "302",
  Oroszló: "302",
  Pamuk: "302",
  Hásságy: "303",
  Erzsébet: "304",
  Kásád: "304",
  Csömend: "304",
  Bakóca: "305",
  Szabadi: "305",
  Kistótfalu: "307",
  Lovászhetény: "308",
  Kisszékely: "310",
  Fonó: "311",
  Rinyaújlak: "312",
  Szentdénes: "315",
  Gyugy: "315",
  Gyöngyösmellék: "316",
  Csibrák: "317",
  Udvari: "317",
  Csákány: "318",
  Alsómocsolád: "320",
  Kazsok: "320",
  Szentbalázs: "321",
  Teklafalu: "323",
  Matty: "326",
  Patalom: "327",
  Nyim: "328",
  Szalatnak: "330",
  Kismányok: "331",
  Koppányszántó: "331",
  Nagyváty: "333",
  Kistormás: "334",
  Egyházasharaszti: "337",
  Diósberény: "338",
  Mőcsény: "338",
  Kárász: "339",
  Nagyhajmás: "339",
  Téseny: "339",
  Hencse: "339",
  Kelevíz: "340",
  Zics: "342",
  Zádor: "343",
  Nagytótfalu: "344",
  Szava: "345",
  Endrőc: "346",
  Old: "346",
  Bélavár: "347",
  Szenyér: "348",
  Botykapeterd: "349",
  Kaposkeresztúr: "349",
  Magyarmecske: "351",
  Pálmajor: "352",
  Mucsfa: "354",
  Kővágótöttös: "355",
  Szebény: "355",
  Ófalu: "358",
  Belecska: "358",
  Erdősmecske: "359",
  Rózsafa: "359",
  Gadány: "359",
  Aranyosgadány: "363",
  Somogyhatvan: "364",
  Kisvaszar: "366",
  Patapoklosi: "368",
  Szőkéd: "370",
  Hács: "373",
  Simonfa: "373",
  Görcsönydoboka: "386",
  Drávatamási: "387",
  Pusztaszemes: "387",
  Bakonya: "388",
  Szentegát: "388",
  Gilvánfa: "389",
  Nagycsepely: "389",
  Nagypall: "390",
  Varsád: "391",
  Felsőmocsolád: "392",
  Kercseliget: "392",
  Hedrehely: "399",
  Gige: "400",
  Táska: "400",
  Cserdi: "401",
  Szenta: "402",
  Törökkoppány: "402",
  Kisbárapáti: "407",
  Bedegkér: "408",
  Bodrog: "408",
  Bátaapáti: "409",
  Hegyszentmárton: "411",
  Liget: "413",
  Rinyaszentkirály: "414",
  Belvárdgyula: "415",
  Ócsárd: "417",
  Somodor: "418",
  Mecsekpölöske: "419",
  Kisbajom: "419",
  Kisvejke: "419",
  Csertő: "420",
  Zselicszentpál: "421",
  Nagyszékely: "422",
  Drávasztára: "423",
  Bolhás: "423",
  Kánya: "425",
  Márok: "428",
  Boldogasszonyfa: "429",
  Zselickislak: "430",
  Bikács: "430",
  Boda: "431",
  Borjád: "431",
  Zengővárkony: "433",
  Csoma: "435",
  Büssü: "436",
  Bonyhádvarasd: "442",
  Somogyhárságy: "444",
  Tengőd: "447",
  Almamellék: "448",
  Bogádmindszent: "448",
  Somogygeszti: "449",
  Ráksi: "455",
  Várda: "459",
  Kaposhomok: "460",
  Baranyajenő: "465",
  Hetvehely: "471",
  Somogymeggyes: "472",
  Mucsi: "473",
  Kémes: "474",
  Somogybabod: "476",
  Szemely: "480",
  Helesfa: "482",
  Sumony: "483",
  Somogytúr: "485",
  Siklósnagyfalu: "487",
  Balatonújlak: "493",
  Őrtilos: "493",
  Somogyapáti: "500",
  Sántos: "502",
  Kisharsány: "507",
  Pogányszentpéter: "507",
  Nagyszakácsi: "508",
  Sávoly: "508",
  Máriakéménd: "509",
  Vörs: "509",
  Izmény: "509",
  Lippó: "510",
  Bőszénfa: "511",
  Iharos: "511",
  Zákányfalu: "515",
  Lengyel: "520",
  Nak: "526",
  Szentgáloskér: "528",
  Birján: "529",
  Romonya: "538",
  Vízvár: "538",
  Kötcse: "541",
  Orci: "543",
  Somogyfajsz: "549",
  Drávafok: "551",
  Kereki: "551",
  Kőkút: "554",
  Pörböly: "557",
  Bár: "559",
  Homorúd: "559",
  Zimány: "560",
  Balatonőszöd: "561",
  Somogyzsitfa: "564",
  Töttös: "565",
  Gerde: "568",
  Nagykorpád: "570",
  Székelyszabar: "575",
  Szabás: "576",
  Szólád: "586",
  Lad: "592",
  Lakócsa: "592",
  Dencsháza: "596",
  Bálványos: "596",
  Istvándi: "599",
  Nágocs: "606",
  Szulok: "606",
  Kálmáncsa: "608",
  Magyaregres: "611",
  Beleg: "621",
  Nagydobsza: "626",
  Cserkút: "628",
  Csányoszró: "631",
  Jákó: "631",
  Olasz: "633",
  Felsőnána: "637",
  Mike: "640",
  Szálka: "644",
  Siójut: "645",
  Sátorhely: "648",
  Magyarhertelend: "654",
  Kapoly: "655",
  Györe: "659",
  Pári: "669",
  Nagypeterd: "672",
  Drávaszabolcs: "684",
  Kökény: "685",
  Tapsony: "685",
  Szántód: "690",
  Nagynyárád: "702",
  Fácánkert: "702",
  Som: "703",
  Kéty: "704",
  Abaliget: "706",
  Diósviszló: "706",
  Sárpilis: "707",
  Alsónána: "709",
  Kétújfalu: "710",
  Bikal: "715",
  Kaposújlak: "718",
  Fürged: "719",
  Háromfa: "724",
  Somogysámson: "724",
  Gyód: "725",
  Somogyszil: "728",
  Bolhó: "729",
  Kisdorog: "730",
  Babarc: "732",
  Vése: "735",
  Alsónyék: "738",
  Nemesvid: "740",
  Értény: "744",
  Egyházaskozár: "746",
  Mórágy: "753",
  Gamás: "755",
  Magyaregregy: "759",
  Szenna: "767",
  Somogyaszaló: "768",
  Mánfa: "777",
  Balatonmáriafürdő: "780",
  Nikla: "783",
  Geresdlak: "787",
  Attala: "788",
  Bábonymegyer: "792",
  Somogyvámos: "793",
  Osztopán: "795",
  Baté: "796",
  Magyaratád: "806",
  Baksa: "809",
  Nemesdéd: "810",
  Medina: "810",
  Szabadszentkirály: "812",
  Pécsudvard: "814",
  Somogyszentpál: "814",
  Váralja: "823",
  Szajk: "827",
  Szakcs: "838",
  Csikóstőttős: "840",
  Vokány: "845",
  Ordacsehi: "847",
  Pusztakovácsi: "847",
  Szentlászló: "848",
  Gödre: "849",
  Harc: "855",
  Felsőszentmárton: "861",
  Kapospula: "863",
  Palotabozsok: "866",
  Gölle: "866",
  Mindszentgodisa: "876",
  Nagyszokoly: "886",
  Berkesd: "892",
  Kiskorpád: "894",
  Cikó: "910",
  Mosdós: "921",
  Darány: "931",
  Magyarbóly: "936",
  Ötvöskónyi: "943",
  Királyegyháza: "945",
  Mozsgó: "947",
  Majs: "950",
  Gyulaj: "958",
  Hobol: "960",
  Versend: "969",
  Gyékényes: "996",
  Györköny: "997",
  Egerág: "1008",
  Somogyudvarhely: "1014",
  Kaposszerdahely: "1018",
  Tolnanémedi: "1018",
  Magyarszék: "1025",
  Aparhant: "1029",
  Újpetre: "1032",
  Himesháza: "1033",
  Pusztahencse: "1036",
  Bicsérd: "1060",
  Kölked: "1063",
  Csököly: "1063",
  Nagykónyi: "1063",
  Sárszentlőrinc: "1063",
  Andocs: "1075",
  Felsőnyék: "1077",
  Orfű: "1082",
  Homokszentgyörgy: "1091",
  Zákány: "1116",
  Regöly: "1127",
  Vásárosdombó: "1132",
  Bogád: "1140",
  Bükkösd: "1141",
  Görgeteg: "1144",
  Kurd: "1146",
  Kajdacs: "1150",
  Hetes: "1161",
  Tarany: "1169",
  Balatonberény: "1174",
  Bárdudvarnok: "1174",
  Szalánta: "1176",
  Magyarkeszi: "1181",
  Juta: "1182",
  Várdomb: "1190",
  Mezőcsokonya: "1218",
  Máza: "1228",
  Inke: "1251",
  Gerjen: "1258",
  Alsószentmárton: "1259",
  Kocsola: "1265",
  Dalmand: "1275",
  Pogány: "1287",
  Sióagárd: "1291",
  Iharosberény: "1296",
  Szakály: "1298",
  Mesztegnyő: "1299",
  Szőlősgyörök: "1305",
  Somogysárd: "1309",
  Mernye: "1328",
  Nagyberény: "1343",
  Kővágószőlős: "1357",
  Balatonendréd: "1367",
  Tevel: "1374",
  Keszü: "1385",
  Látrány: "1399",
  Véménd: "1430",
  Kőröshegy: "1430",
  Nagyberki: "1450",
  Kutas: "1462",
  Somberek: "1466",
  Igal: "1483",
  Balatonvilágos: "1484",
  Nagyharsány: "1490",
  Kaposszekcső: "1496",
  Kölesd: "1503",
  Babócsa: "1508",
  Buzsák: "1510",
  Pálfa: "1514",
  Öreglak: "1525",
  Somogyszob: "1532",
  Görcsöny: "1546",
  Somogyjád: "1560",
  Karád: "1571",
  Csokonyavisonta: "1579",
  Mecseknádasd: "1581",
  Kaposfő: "1583",
  Báta: "1596",
  Ozora: "1636",
  Balatonkeresztúr: "1660",
  Balatonszentgyörgy: "1697",
  Kakasd: "1715",
  Szederkény: "1722",
  Németkér: "1746",
  Somogyvár: "1752",
  Gyönk: "1766",
  Vajszló: "1779",
  Balatonszemes: "1827",
  Lábod: "1881",
  Dunaszekcső: "1892",
  Madocsa: "1898",
  Ságvár: "1900",
  Döbrököz: "1960",
  Taszár: "2018",
  Zomba: "2029",
  Nagykozár: "2071",
  Hidas: "2107",
  Ádánd: "2150",
  Szedres: "2171",
  Pincehely: "2172",
  Bogyiszló: "2182",
  Tengelic: "2224",
  Balatonfenyves: "2231",
  Balatonszárszó: "2232",
  Böhönye: "2295",
  Balatonföldvár: "2302",
  Nagymányok: "2303",
  Villány: "2307",
  Pellérd: "2309",
  Mágocs: "2313",
  Kéthely: "2331",
  Szászvár: "2339",
  Őcsény: "2431",
  Beremend: "2441",
  Kaposmérő: "2453",
  Kadarkút: "2458",
  Berzence: "2460",
  Segesd: "2497",
  Lánycsók: "2529",
  Dunaszentgyörgy: "2586",
  Zamárdi: "2637",
  Iregszemcse: "2656",
  Nagydorog: "2661",
  Sellye: "2736",
  Bölcske: "2739",
  Hőgyész: "2803",
  Balatonszabadi: "3013",
  Sásd: "3051",
  Lengyeltóti: "3087",
  Nagybajom: "3191",
  Hosszúhetény: "3464",
  Bóly: "3772",
  Simontornya: "3917",
  Pécsvárad: "4007",
  Decs: "4113",
  Fadd: "4233",
  Tab: "4378",
  Harkány: "4762",
  Balatonlelle: "4875",
  Csurgó: "4905",
  Fonyód: "5183",
  Balatonboglár: "5883",
  Kozármisleny: "6434",
  Bátaszék: "6501",
  Szentlőrinc: "6520",
  Tamási: "8115",
  Dunaföldvár: "8510",
  Siklós: "9730",
  Szigetvár: "10450",
  Nagyatád: "10481",
  Barcs: "10939",
  Marcali: "11465",
  Tolna: "11607",
  Bonyhád: "13060",
  Dombóvár: "18555",
  Paks: "18666",
  Mohács: "18756",
  Komló: "24886",
  Siófok: "25095",
  Szekszárd: "32488",
  Kaposvár: "63298",
  Pécs: "148030"
};

//térkép színskála kaluláció
var maxCasesUnder = {
  positiveTestPerCapita: 0,
  level1: 0,
  level2: 0,
  level3: 0,
  level4: 0,
  level5: 0
};

var maxCasesOver = {
  positiveTestPerCapita: 0,
  level1: 0,
  level2: 0,
  level3: 0,
  level4: 0,
  level5: 0
};

for (
  let i = 0;
  i < pte_city_timeline[pte_city_timeline.length - 1].list.length;
  i++
) {
  let cityPopulation = Number(
    populations[
      pte_city_timeline[pte_city_timeline.length - 1].list[i].cityName
    ]
  );
  let noTest =
    pte_city_timeline[pte_city_timeline.length - 1].list[i].noSymptonPositive;
  let posTest =
    pte_city_timeline[pte_city_timeline.length - 1].list[i].hasSymptonPositive;
  let infections = ((noTest + posTest) / cityPopulation) * 100000;

  if (cityPopulation < 1500) {
    if (maxCasesUnder.positiveTestPerCapita < infections) {
      maxCasesUnder.positiveTestPerCapita = infections;
    }
  } else {
    if (maxCasesOver.positiveTestPerCapita < infections) {
      maxCasesOver.positiveTestPerCapita = infections;
    }
  }
}

maxCasesUnder.level5 = Math.round(maxCasesUnder.positiveTestPerCapita * 0.8);
maxCasesUnder.level4 = Math.round(maxCasesUnder.positiveTestPerCapita * 0.6);
maxCasesUnder.level3 = Math.round(maxCasesUnder.positiveTestPerCapita * 0.4);
maxCasesUnder.level2 = Math.round(maxCasesUnder.positiveTestPerCapita * 0.2);

maxCasesOver.level5 = Math.round(maxCasesOver.positiveTestPerCapita * 0.8);
maxCasesOver.level4 = Math.round(maxCasesOver.positiveTestPerCapita * 0.6);
maxCasesOver.level3 = Math.round(maxCasesOver.positiveTestPerCapita * 0.4);
maxCasesOver.level2 = Math.round(maxCasesOver.positiveTestPerCapita * 0.2);

/* Chart code */
// Themes begin
am4core.useTheme(am4themes_animated);
// Themes end
am4core.ready(function() {
  let numberFormatter = new am4core.NumberFormatter();

  let backgroundColor = am4core.color("#192533");
  let testsColor = am4core.color("#A7834F");
  let positiveColor = am4core.color("#d21a1a");
  let averageAgeColor = am4core.color("#45d21a");
  let averageCpColor = am4core.color("#1c5fe5");
  let noSymptonPositiveColor = am4core.color("#ffdd57");
  let hasSymptonPositiveColor = am4core.color("#ad1ad2");

  let lastHoverColor = null;
  let lastHoverPolygon = null;

  // for an easier access by key
  let colors = {
    active: testsColor,
    positive: positiveColor,
    age: averageAgeColor,
    cp: averageCpColor,
    noSymptonPositive: noSymptonPositiveColor,
    hasSymptonPositive: hasSymptonPositiveColor
  };

  let cityColor = am4core.color("#26ff00");
  let cityStrokeColor = am4core.color("#000000");
  let buttonStrokeColor = am4core.color("#ffffff");
  let cityHoverColor = am4core.color("#223241");
  let activeCityColor = am4core.color("#08002e");

  let safeColor = am4core.color("#26ff00");
  let warningColor = am4core.color("#e1ff00");
  let dangerColor = am4core.color("#ff0000");

  let colorRedOne = am4core.color("#ff9494");
  let colorRedTwo = am4core.color("#ed5c5c");
  let colorRedThree = am4core.color("#c92e2e");
  let colorRedFour = am4core.color("#a61111");
  let colorRedFive = am4core.color("#730000");

  let currentIndex;
  let currentCity = "Southern Transdanubia";

  // last date of the data
  let lastDate = new Date(
    total_timeline_sum[total_timeline_sum.length - 1].date
  );

  let currentDate = lastDate;

  let currentPolygon;

  let cityDataTimeout;

  let currentType;

  let currentTypeName;

  let index;

  var dateIndex = pte_city_timeline.length - 1;

  let sliderAnimation;

  let perCapita = true;

  //////////////////////////////////////////////////////////////////////////////
  // PREPARE DATA
  //////////////////////////////////////////////////////////////////////////////

  // make a map of city indexes for later use
  let cityIndexMap = {};
  let list = pte_city_timeline[pte_city_timeline.length - 1].list;
  for (var i = 0; i < list.length; i++) {
    let city = list[i];
    cityIndexMap[city.cityName] = i;
  }

  // calculated active cases in region data (active = confirmed - recovered)
  for (var i = 0; i < total_timeline_sum.length; i++) {
    let di = total_timeline_sum[i];
    di.positiveTests = di.hasSymptonPositive + di.noSymptonPositive;
  }

  // function that returns current slide
  // if index is not set, get last slide
  function getSlideData(index) {
    if (index == undefined) {
      index = pte_city_timeline.length - 1;
    }

    let data = pte_city_timeline[index];
    return data;
  }

  // get slide data
  let slideData = getSlideData();

  // as we will be modifying raw data, make a copy
  let mapData = JSON.parse(JSON.stringify(slideData.list));
  // remove items with 0 values for better performance
  for (var i = mapData.length - 1; i >= 0; i--) {
    if (mapData[i].testSum == 0) {
      mapData.splice(i, 1);
    }
  }

  let max = {
    tests: 1600,
    averageAge: 80,
    averageCp: 50,
    hasSymptonPositive: 350,
    noSymptonPositive: 300,
    positiveTests: 650
  };
  let maxPC = {
    tests: 0,
    averageAge: 0,
    averageCp: 0,
    hasSymptonPositive: 0,
    noSymptonPositive: 0,
    positiveTests: 0
  };

  // END OF DATA

  //////////////////////////////////////////////////////////////////////////////
  // LAYOUT & CHARTS
  //////////////////////////////////////////////////////////////////////////////

  // main container
  // https://www.amcharts.com/docs/v4/concepts/svg-engine/containers/

  setTimeout(() => {
    let container = am4core.create("chartdiv", am4core.Container);

    container.width = am4core.percent(100);
    container.height = am4core.percent(100);

    container.tooltip = new am4core.Tooltip();
    container.tooltip.background.fill = am4core.color("#000000");
    container.tooltip.background.stroke = testsColor;
    container.tooltip.fontSize = "0.9em";
    container.tooltip.getFillFromObject = false;
    container.tooltip.getStrokeFromObject = false;

    // MAP CHART
    // https://www.amcharts.com/docs/v4/chart-types/map/
    let mapChart = container.createChild(am4maps.MapChart);
    mapChart.height = am4core.percent(60);
    mapChart.zoomControl = new am4maps.ZoomControl();
    mapChart.zoomControl.align = "right";
    mapChart.zoomControl.marginRight = 15;
    mapChart.zoomControl.valign = "middle";
    mapChart.draggable = false;
    mapChart.homeGeoPoint = { longitude: 18.14, latitude: 46.4 };

    mapChart.seriesContainer.background.events.on("hit", showWorld);
    mapChart.zoomEasing = am4core.ease.sinOut;

    // https://www.amcharts.com/docs/v4/chart-types/map/#Map_data
    // you can use more accurate world map or map of any other city - a wide selection of maps available at: https://github.com/amcharts/amcharts4-geodata
    //mapChart.geodata = am4geodata_worldLow;
    mapChart.geodataSource.url =
      "https://gist.githubusercontent.com/Robirodalom/92cf4441e8b51e15ce379ca4e64bce7c/raw/121fce53605a9cd06d2ec648580339409a99c712/dunantul-separated.json";

    // Set projection
    // https://www.amcharts.com/docs/v4/chart-types/map/#Setting_projection
    // instead of Miller, you can use Mercator or many other projections available: https://www.amcharts.com/demos/map-using-d3-projections/
    mapChart.projection = new am4maps.projections.Miller();
    mapChart.panBehavior = "move";

    // when map is globe, beackground is made visible
    // mapChart.backgroundSeries.mapPolygons.template.polygon.fillOpacity = 0.05;
    // mapChart.backgroundSeries.mapPolygons.template.polygon.fill = am4core.color(
    //   "#ffffff"
    // );
    // mapChart.backgroundSeries.hidden = true;

    // Map polygon series (defines how city areas look and behave)
    let polygonSeries = mapChart.series.push(new am4maps.MapPolygonSeries());
    polygonSeries.dataFields.id = "cityName";
    polygonSeries.dataFields.value = "testSum";

    polygonSeries.interpolationDuration = 0;

    //polygonSeries.exclude = ["AQ"]; // Antarctica is excluded in non-globe projection
    polygonSeries.useGeodata = true;
    polygonSeries.nonScalingStroke = true;
    polygonSeries.strokeWidth = 0.5;
    // this helps to place bubbles in the visual middle of the area
    polygonSeries.calculateVisualCenter = true;

    polygonSeries.data = mapData;

    let polygonTemplate = polygonSeries.mapPolygons.template;
    polygonTemplate.fill = cityColor;
    polygonTemplate.fillOpacity = 1;
    polygonTemplate.stroke = cityStrokeColor;
    polygonTemplate.strokeOpacity = 0.15;
    polygonTemplate.setStateOnChildren = true;
    polygonTemplate.tooltipPosition = "fixed";

    polygonTemplate.events.on("hit", handleCityHit);
    polygonTemplate.events.on("over", handleCityOver);
    polygonTemplate.events.on("out", handleCityOut);
    polygonTemplate.events.on("virusColor", handleVirusColor);

    polygonSeries.heatRules.push({
      target: polygonTemplate,
      property: "fill",
      min: cityColor,
      max: cityColor,
      dataField: "value"
    });

    // you can have pacific - centered map if you set this to -154.8
    mapChart.deltaLongitude = 18.14;

    // polygon states
    let polygonHoverState = polygonTemplate.states.create("hover");
    polygonHoverState.transitionDuration = 1400;
    //polygonHoverState.properties.fill = cityHoverColor;

    // let polygonSafeState = polygonTemplate.states.create("safe");
    // polygonSafeState.properties.fill = safeColor;

    // let polygonWarningState = polygonTemplate.states.create("warning");
    // polygonWarningState.properties.fill = warningColor;

    // let polygonDangerState = polygonTemplate.states.create("danger");
    // polygonDangerState.properties.fill = dangerColor;

    // let polygonActiveState = polygonTemplate.states.create("active");
    // polygonActiveState.properties.fill = activeCityColor;

    // Bubble series
    let bubbleSeries = mapChart.series.push(new am4maps.MapImageSeries());
    bubbleSeries.data = JSON.parse(JSON.stringify(mapData));

    bubbleSeries.dataFields.value = "testSum";
    bubbleSeries.dataFields.id = "cityName";

    // adjust tooltip
    bubbleSeries.tooltip.animationDuration = 0;
    bubbleSeries.tooltip.showInViewport = false;
    bubbleSeries.tooltip.background.fillOpacity = 0.2;
    bubbleSeries.tooltip.getStrokeFromObject = true;
    bubbleSeries.tooltip.getFillFromObject = false;
    bubbleSeries.tooltip.background.fillOpacity = 0.2;
    bubbleSeries.tooltip.background.fill = am4core.color("#000000");

    let imageTemplate = bubbleSeries.mapImages.template;
    // if you want bubbles to become bigger when zoomed, set this to false
    imageTemplate.nonScaling = true;
    imageTemplate.strokeOpacity = 0;
    imageTemplate.fillOpacity = 0.55;
    //imageTemplate.tooltipText = "{cityName}: [bold]{value}[/]";
    polygonTemplate.tooltipText = "{NAME} {value}";
    imageTemplate.applyOnClones = true;

    imageTemplate.events.on("over", handleImageOver);
    imageTemplate.events.on("out", handleImageOut);
    imageTemplate.events.on("hit", handleImageHit);

    // this is needed for the tooltip to point to the top of the circle instead of the middle
    imageTemplate.adapter.add("tooltipY", function(tooltipY, target) {
      return -target.children.getIndex(0).radius;
    });

    // When hovered, circles become non-opaque
    let imageHoverState = imageTemplate.states.create("hover");
    imageHoverState.properties.fillOpacity = 1;

    // add circle inside the image
    let circle = imageTemplate.createChild(am4core.Circle);
    // this makes the circle to pulsate a bit when showing it
    circle.hiddenState.properties.scale = 0.0001;
    circle.hiddenState.transitionDuration = 2000;
    circle.defaultState.transitionDuration = 2000;
    circle.defaultState.transitionEasing = am4core.ease.elasticOut;
    // later we set fill color on template (when changing what type of data the map should show) and all the clones get the color because of this
    circle.applyOnClones = true;

    // heat rule makes the bubbles to be of a different width. Adjust min/max for smaller/bigger radius of a bubble
    bubbleSeries.heatRules.push({
      target: circle,
      property: "radius",
      min: 3,
      max: 30,
      dataField: "value"
    });

    // when data items validated, hide 0 value bubbles (because min size is set)
    bubbleSeries.events.on("dataitemsvalidated", function() {
      bubbleSeries.dataItems.each(dataItem => {
        let mapImage = dataItem.mapImage;
        let circle = mapImage.children.getIndex(0);
        if (mapImage.dataItem.value == 0) {
          circle.hide(0);
        } else if (circle.isHidden || circle.isHiding) {
          circle.show();
        }
      });
    });

    // this places bubbles at the visual center of a city
    imageTemplate.adapter.add("latitude", function(latitude, target) {
      let polygon = polygonSeries.getPolygonById(target.dataItem.id);
      if (polygon) {
        target.disabled = false;
        return polygon.visualLatitude;
      } else {
        target.disabled = true;
      }
      return latitude;
    });

    imageTemplate.adapter.add("longitude", function(longitude, target) {
      let polygon = polygonSeries.getPolygonById(target.dataItem.id);
      if (polygon) {
        target.disabled = false;
        return polygon.visualLongitude;
      } else {
        target.disabled = true;
      }
      return longitude;
    });

    // END OF MAP

    // top title
    let title = mapChart.titles.create();
    title.fontSize = "1.2em";
    title.text = `COVID-19 Spread Data Southern Transdanubia (${pte_totalData_city.length} settlements) - Hungary.`;
    title.fill = am4core.color("#000000");
    title.align = "left";
    title.horizontalCenter = "left";
    title.marginLeft = 20;
    title.paddingBottom = 10;
    title.y = 20;

    //LEGENDS ON THE SIDE MAP

    let legendLabelInfo = mapChart.createChild(am4core.Label);
    legendLabelInfo.text =
      "Settlements colors are calculated as per capita ( pro 100 000 people )";
    legendLabelInfo.fontSize = "0.8em";
    legendLabelInfo.fill = am4core.color("#000000");
    legendLabelInfo.align = "left";
    legendLabelInfo.horizontalCenter = "left";
    legendLabelInfo.marginLeft = 20;
    legendLabelInfo.paddingBottom = 10;
    legendLabelInfo.y = 90;

    let legendLabel1 = mapChart.createChild(am4core.Label);
    legendLabel1.text = "Bottom 20% of the maximum infected per capita";
    legendLabel1.fontSize = "0.9em";
    legendLabel1.fill = am4core.color("#000000");
    legendLabel1.align = "left";
    legendLabel1.horizontalCenter = "left";
    legendLabel1.marginLeft = 20;
    legendLabel1.paddingBottom = 10;
    legendLabel1.y = 120;

    let legendLabelRect1 = mapChart.createChild(am4core.Rectangle);
    legendLabelRect1.width = 30;
    legendLabelRect1.height = 40;
    legendLabelRect1.fill = colorRedOne;
    legendLabelRect1.align = "left";
    legendLabelRect1.horizontalCenter = "left";
    legendLabelRect1.marginLeft = 340;
    legendLabelRect1.paddingBottom = 10;
    legendLabelRect1.y = 115;

    let legendLabel2 = mapChart.createChild(am4core.Label);
    legendLabel2.text = "Between 20% and 40% of the maximum value";
    legendLabel2.fontSize = "0.9em";
    legendLabel2.fill = am4core.color("#000000");
    legendLabel2.align = "left";
    legendLabel2.horizontalCenter = "left";
    legendLabel2.marginLeft = 20;
    legendLabel2.paddingBottom = 10;
    legendLabel2.y = 160;

    let legendLabelRect2 = mapChart.createChild(am4core.Rectangle);
    legendLabelRect2.width = 30;
    legendLabelRect2.height = 40;
    legendLabelRect2.fill = colorRedTwo;
    legendLabelRect2.align = "left";
    legendLabelRect2.horizontalCenter = "left";
    legendLabelRect2.marginLeft = 340;
    legendLabelRect2.paddingBottom = 10;
    legendLabelRect2.y = 155;

    let legendLabel3 = mapChart.createChild(am4core.Label);
    legendLabel3.text = "Between 40% and 60% of the maximum value";
    legendLabel3.fontSize = "0.9em";
    legendLabel3.fill = am4core.color("#000000");
    legendLabel3.align = "left";
    legendLabel3.horizontalCenter = "left";
    legendLabel3.marginLeft = 20;
    legendLabel3.paddingBottom = 10;
    legendLabel3.y = 200;

    let legendLabelRect3 = mapChart.createChild(am4core.Rectangle);
    legendLabelRect3.width = 30;
    legendLabelRect3.height = 40;
    legendLabelRect3.fill = colorRedThree;
    legendLabelRect3.align = "left";
    legendLabelRect3.horizontalCenter = "left";
    legendLabelRect3.marginLeft = 340;
    legendLabelRect3.paddingBottom = 10;
    legendLabelRect3.y = 195;

    let legendLabel4 = mapChart.createChild(am4core.Label);
    legendLabel4.text = "Between 60% and 80% of the maximum value";
    legendLabel4.fontSize = "0.9em";
    legendLabel4.fill = am4core.color("#000000");
    legendLabel4.align = "left";
    legendLabel4.horizontalCenter = "left";
    legendLabel4.marginLeft = 20;
    legendLabel4.paddingBottom = 10;
    legendLabel4.y = 240;

    let legendLabelRect4 = mapChart.createChild(am4core.Rectangle);
    legendLabelRect4.width = 30;
    legendLabelRect4.height = 40;
    legendLabelRect4.fill = colorRedFour;
    legendLabelRect4.align = "left";
    legendLabelRect4.horizontalCenter = "left";
    legendLabelRect4.marginLeft = 340;
    legendLabelRect4.paddingBottom = 10;
    legendLabelRect4.y = 235;

    let legendLabel5 = mapChart.createChild(am4core.Label);
    legendLabel5.text = "Over 80% of the maximum value";
    legendLabel5.fontSize = "0.9em";
    legendLabel5.fill = am4core.color("#000000");
    legendLabel5.align = "left";
    legendLabel5.horizontalCenter = "left";
    legendLabel5.marginLeft = 20;
    legendLabel5.paddingBottom = 10;
    legendLabel5.y = 280;

    let legendLabelRect5 = mapChart.createChild(am4core.Rectangle);
    legendLabelRect5.width = 30;
    legendLabelRect5.height = 40;
    legendLabelRect5.fill = colorRedFive;
    legendLabelRect5.align = "left";
    legendLabelRect5.horizontalCenter = "left";
    legendLabelRect5.marginLeft = 340;
    legendLabelRect5.paddingBottom = 10;
    legendLabelRect5.y = 275;

    let formulaInfo = mapChart.createChild(am4core.Label);
    formulaInfo.text =
      "Maximum values are calculated separately for settlements under 1500 population\nand settlements with 1500 population or higher\nCalculated as the sum of the \npositive test in a settlement divided by the population and multiplied by 100 000";
    formulaInfo.fontSize = "0.6em";
    formulaInfo.fill = am4core.color("#000000");
    formulaInfo.align = "left";
    formulaInfo.horizontalCenter = "left";
    formulaInfo.marginLeft = 20;
    formulaInfo.paddingBottom = 10;
    formulaInfo.y = 320;

    // buttons & chart container
    let buttonsAndChartContainer = container.createChild(am4core.Container);
    buttonsAndChartContainer.layout = "vertical";
    buttonsAndChartContainer.height = am4core.percent(38); // make this bigger if you want more space for the chart
    buttonsAndChartContainer.width = am4core.percent(100);
    buttonsAndChartContainer.valign = "bottom";

    // city name and buttons container
    let nameAndButtonsContainer = buttonsAndChartContainer.createChild(
      am4core.Container
    );
    nameAndButtonsContainer.width = am4core.percent(100);
    nameAndButtonsContainer.padding(0, 10, 5, 20);
    nameAndButtonsContainer.layout = "horizontal";

    // name of a city and date label
    let cityName = nameAndButtonsContainer.createChild(am4core.Label);
    cityName.fontSize = "1.1em";
    cityName.fill = am4core.color("#000000");
    cityName.valign = "middle";

    // buttons container (active/confirmed/recovered/deaths)
    let buttonsContainer = nameAndButtonsContainer.createChild(
      am4core.Container
    );
    buttonsContainer.layout = "grid";
    buttonsContainer.width = am4core.percent(100);
    buttonsContainer.x = 10;
    buttonsContainer.contentAlign = "right";

    // Chart & slider container
    let chartAndSliderContainer = buttonsAndChartContainer.createChild(
      am4core.Container
    );
    chartAndSliderContainer.layout = "vertical";
    chartAndSliderContainer.height = am4core.percent(100);
    chartAndSliderContainer.width = am4core.percent(100);
    chartAndSliderContainer.background = new am4core.RoundedRectangle();
    chartAndSliderContainer.background.fill = am4core.color("#000000");
    chartAndSliderContainer.background.cornerRadius(30, 30, 0, 0);
    chartAndSliderContainer.background.fillOpacity = 0.7;
    chartAndSliderContainer.paddingTop = 12;
    chartAndSliderContainer.paddingBottom = 0;

    // Slider container
    let sliderContainer = chartAndSliderContainer.createChild(
      am4core.Container
    );
    sliderContainer.width = am4core.percent(100);
    sliderContainer.padding(0, 0, 0, 0);
    sliderContainer.layout = "horizontal";

    let slider = sliderContainer.createChild(am4core.Slider);
    slider.width = am4core.percent(100);
    slider.valign = "middle";
    slider.background.opacity = 0.4;
    slider.opacity = 0.7;
    slider.background.fill = am4core.color("#ffffff");
    slider.marginLeft = 40;
    slider.marginRight = 60;
    slider.height = 15;
    slider.start = 0;

    // what to do when slider is dragged
    slider.events.on("rangechanged", function(event) {
      index = Math.round((pte_city_timeline.length - 1) * slider.start);
      dateIndex = index;
      updateMapData(getSlideData(index).list);
      updateTotals(index);
    });
    // stop animation if dragged
    slider.startGrip.events.on("drag", () => {
      stop();
      if (sliderAnimation) {
        sliderAnimation.setProgress(slider.start);
      }
    });

    // play button
    let playButton = sliderContainer.createChild(am4core.PlayButton);
    playButton.valign = "middle";
    // play button behavior
    playButton.events.on("toggled", function(event) {
      if (event.target.isActive) {
        play();
      } else {
        stop();
      }
    });
    // make slider grip look like play button
    slider.startGrip.background.fill = playButton.background.fill;
    slider.startGrip.background.strokeOpacity = 0;
    slider.startGrip.icon.stroke = am4core.color("#ffffff");
    slider.startGrip.background.states.copyFrom(playButton.background.states);

    // play behavior
    function play() {
      if (!sliderAnimation) {
        sliderAnimation = slider
          .animate(
            { property: "start", to: 1, from: 0 },
            120000,
            am4core.ease.linear
          )
          .pause();
        sliderAnimation.events.on("animationended", () => {
          playButton.isActive = false;
        });
      }

      if (slider.start >= 1) {
        slider.start = 0;
        sliderAnimation.start();
      }
      sliderAnimation.resume();
      playButton.isActive = true;
    }

    // stop behavior
    function stop() {
      if (sliderAnimation) {
        sliderAnimation.pause();
      }
      playButton.isActive = false;
    }

    // BOTTOM CHART
    // https://www.amcharts.com/docs/v4/chart-types/xy-chart/
    let lineChart = chartAndSliderContainer.createChild(am4charts.XYChart);
    lineChart.fontSize = "0.8em";
    lineChart.paddingRight = 40;
    lineChart.paddingLeft = 40;
    lineChart.maskBullets = false;
    lineChart.zoomOutButton.disabled = true;
    lineChart.paddingBottom = 5;
    lineChart.paddingTop = 3;

    // make a copy of data as we will be modifying it
    lineChart.data = JSON.parse(JSON.stringify(total_timeline_sum));

    // date axis
    // https://www.amcharts.com/docs/v4/concepts/axes/date-axis/
    let dateAxis = lineChart.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.minGridDistance = 50;
    dateAxis.renderer.grid.template.stroke = am4core.color("#000000");
    dateAxis.renderer.grid.template.strokeOpacity = 0.25;
    dateAxis.max = lastDate.getTime() + am4core.time.getDuration("day", 5);
    dateAxis.tooltip.label.fontSize = "0.8em";
    dateAxis.tooltip.background.fill = testsColor;
    dateAxis.tooltip.background.stroke = testsColor;
    dateAxis.renderer.labels.template.fill = am4core.color("#ffffff");
    /*
  dateAxis.renderer.labels.template.adapter.add("fillOpacity", function(fillOpacity, target){
      return dateAxis.valueToPosition(target.dataItem.value) + 0.1;
  })*/

    // value axis
    // https://www.amcharts.com/docs/v4/concepts/axes/value-axis/
    let valueAxis = lineChart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.opposite = true;
    valueAxis.interpolationDuration = 3000;
    valueAxis.renderer.grid.template.stroke = am4core.color("#000000");
    valueAxis.renderer.grid.template.strokeOpacity = 0.25;
    valueAxis.renderer.minGridDistance = 30;
    valueAxis.renderer.maxLabelPosition = 0.98;
    valueAxis.renderer.baseGrid.disabled = true;
    valueAxis.tooltip.disabled = true;
    valueAxis.extraMax = 0.05;
    valueAxis.maxPrecision = 0;
    valueAxis.renderer.inside = true;
    valueAxis.renderer.labels.template.verticalCenter = "bottom";
    valueAxis.renderer.labels.template.fill = am4core.color("#ffffff");
    valueAxis.renderer.labels.template.padding(2, 2, 2, 2);
    valueAxis.adapter.add("max", function(max, target) {
      if (max < 5) {
        max = 5;
      }
      return max;
    });

    valueAxis.adapter.add("min", function(min, target) {
      if (!seriesTypeSwitch.isActive) {
        if (min < 0) {
          min = 0;
        }
      }
      return min;
    });

    // cursor
    // https://www.amcharts.com/docs/v4/concepts/chart-cursor/
    lineChart.cursor = new am4charts.XYCursor();
    lineChart.cursor.maxTooltipDistance = 0;
    lineChart.cursor.behavior = "none"; // set zoomX for a zooming possibility
    lineChart.cursor.lineY.disabled = true;
    lineChart.cursor.lineX.stroke = testsColor;
    lineChart.cursor.xAxis = dateAxis;
    // this prevents cursor to move to the clicked location while map is dragged
    am4core
      .getInteraction()
      .body.events.off(
        "down",
        lineChart.cursor.handleCursorDown,
        lineChart.cursor
      );
    am4core
      .getInteraction()
      .body.events.off("up", lineChart.cursor.handleCursorUp, lineChart.cursor);

    // legend
    // https://www.amcharts.com/docs/v4/concepts/legend/
    lineChart.legend = new am4charts.Legend();
    lineChart.legend.parent = lineChart.plotContainer;
    lineChart.legend.labels.template.fill = am4core.color("#ffffff");
    lineChart.legend.markers.template.height = 8;
    lineChart.legend.contentAlign = "left";
    lineChart.legend.fontSize = "10px";
    lineChart.legend.itemContainers.template.valign = "middle";
    let legendDown = false;
    lineChart.legend.itemContainers.template.events.on("down", function() {
      legendDown = true;
    });
    lineChart.legend.itemContainers.template.events.on("up", function() {
      setTimeout(function() {
        legendDown = false;
      }, 20);
    });

    let seriesTypeSwitch = lineChart.legend.createChild(am4core.SwitchButton);
    seriesTypeSwitch.leftLabel.text = "totals";
    seriesTypeSwitch.rightLabel.text = "day change";
    seriesTypeSwitch.leftLabel.fill = am4core.color("#ffffff");
    seriesTypeSwitch.rightLabel.fill = am4core.color("#ffffff");

    seriesTypeSwitch.events.on("down", function() {
      legendDown = true;
    });
    seriesTypeSwitch.events.on("up", function() {
      setTimeout(function() {
        legendDown = false;
      }, 200);
    });

    seriesTypeSwitch.events.on("toggled", function() {
      if (seriesTypeSwitch.isActive) {
        if (!columnSeries) {
          createColumnSeries();
        }

        for (var key in columnSeries) {
          columnSeries[key].hide(0);
        }

        for (var key in series) {
          series[key].hiddenInLegend = true;
          series[key].hide();
        }

        if (currentType.includes("tests")) {
          currentType = "active";
        }

        columnSeries[currentType].show();
      } else {
        for (var key in columnSeries) {
          columnSeries[key].hiddenInLegend = true;
          columnSeries[key].hide();
        }

        for (var key in series) {
          series[key].hiddenInLegend = false;
          series[key].hide();
        }
        series[currentType].show();
      }
    });

    function updateColumnsFill() {
      columnSeries.active.columns.each(function(column) {
        if (column.dataItem.values.valueY.previousChange < 0) {
          column.fillOpacity = 0;
          column.strokeOpacity = 0.6;
        } else {
          column.fillOpacity = 0.6;
          column.strokeOpacity = 0;
        }
      });
    }

    // create series
    let testsSeries = addSeries("Tests", testsColor);
    // active series is visible initially
    testsSeries.tooltip.disabled = true;
    testsSeries.hidden = false;

    let confirmedSeries = addSeries("Positive", positiveColor);
    let cpSeries = addSeries("Average CP", averageCpColor);
    let ageSeries = addSeries("Average Age", averageAgeColor);
    let noSymptonPositiveSeries = addSeries(
      "Asymptomatic",
      noSymptonPositiveColor
    );
    let hasSymptonPositiveSeries = addSeries(
      "Symptomatic",
      hasSymptonPositiveColor
    );

    let series = {
      tests: testsSeries,
      confirmed: confirmedSeries,
      cp: cpSeries,
      age: ageSeries,
      noSympton: noSymptonPositiveSeries,
      hasSympton: hasSymptonPositiveSeries
    };
    // add series
    function addSeries(name, color) {
      let series = lineChart.series.push(new am4charts.LineSeries());

      if (name == "Tests") {
        series.dataFields.valueY = "testSum";
      } else if (name == "Positive") {
        series.dataFields.valueY = "positiveTests";
      } else if (name.includes("CP")) {
        series.dataFields.valueY = "averageCp";
      } else if (name.includes("Age")) {
        series.dataFields.valueY = "averageAge";
      } else if (name.includes("Asymptomatic")) {
        series.dataFields.valueY = "noSymptonPositive";
      } else if (name.includes("Symptomatic")) {
        series.dataFields.valueY = "hasSymptonPositive";
      }

      series.dataFields.dateX = "date";

      series.name = capitalizeFirstLetter(name);
      series.strokeOpacity = 0.6;
      series.stroke = color;
      series.fill = color;
      series.maskBullets = false;
      series.minBulletDistance = 10;
      series.hidden = true;
      series.hideTooltipWhileZooming = true;

      // series bullet
      let bullet = series.bullets.push(new am4charts.CircleBullet());

      // only needed to pass it to circle
      let bulletHoverState = bullet.states.create("hover");
      bullet.setStateOnChildren = true;

      bullet.circle.fillOpacity = 1;
      bullet.circle.fill = backgroundColor;
      bullet.circle.radius = 2;

      let circleHoverState = bullet.circle.states.create("hover");
      circleHoverState.properties.fillOpacity = 1;
      circleHoverState.properties.fill = color;
      circleHoverState.properties.scale = 1.4;

      // tooltip setup
      series.tooltip.pointerOrientation = "down";
      series.tooltip.getStrokeFromObject = true;
      series.tooltip.getFillFromObject = false;
      series.tooltip.background.fillOpacity = 0.2;
      series.tooltip.background.fill = am4core.color("#000000");
      series.tooltip.dy = -4;
      series.tooltip.fontSize = "0.8em";
      series.tooltipText = "Total {name}: {valueY}";

      return series;
    }

    //let series = { active: testsSeries, confirmed: confirmedSeries, recovered: recoveredSeries, deaths: deathsSeries };

    let columnSeries;

    function createColumnSeries() {
      columnSeries = {};
      columnSeries.active = addColumnSeries("Active", testsColor);
      columnSeries.active.events.on("validated", function() {
        updateColumnsFill();
      });

      columnSeries.confirmed = addColumnSeries("Positive", positiveColor);
      columnSeries.cp = addColumnSeries("Average CP", averageCpColor);
      columnSeries.age = addColumnSeries("Average Age", averageAgeColor);
    }

    // add series
    function addColumnSeries(name, color) {
      let series = lineChart.series.push(new am4charts.ColumnSeries());

      if (name == "Active") {
        series.dataFields.valueY = "testSum";
        name = "Tests";
      } else if (name.includes("Positive")) {
        series.dataFields.valueY = "positiveTests";
      } else if (name.includes("CP")) {
        series.dataFields.valueY = "averageCp";
      } else if (name.includes("Age")) {
        series.dataFields.valueY = "averageAge";
      } else if (name.includes("No Sympto")) {
        series.dataFields.valueY = "noSymptonPositive";
      } else if (name.includes("Has Sympto")) {
        series.dataFields.valueY = "hasSymptonPositive";
      }

      series.dataFields.valueYShow = "previousChange";
      series.dataFields.dateX = "date";
      series.name = capitalizeFirstLetter(name);
      series.hidden = true;
      series.stroke = color;
      series.fill = color;
      series.columns.template.fillOpacity = 0.6;
      series.columns.template.strokeOpacity = 0;
      series.hideTooltipWhileZooming = true;
      series.clustered = false;
      series.hiddenInLegend = true;
      series.columns.template.width = am4core.percent(50);

      // tooltip setup
      series.tooltip.pointerOrientation = "down";
      series.tooltip.getStrokeFromObject = true;
      series.tooltip.getFillFromObject = false;
      series.tooltip.background.fillOpacity = 0.2;
      series.tooltip.background.fill = am4core.color("#000000");
      series.tooltip.fontSize = "0.8em";
      series.tooltipText = "{name} : {valueY}";

      return series;
    }

    lineChart.plotContainer.events.on("up", function() {
      if (!legendDown) {
        slider.start =
          lineChart.cursor.xPosition *
          ((dateAxis.max - dateAxis.min) / (lastDate.getTime() - dateAxis.min));
      }
    });

    // BUTTONS
    // create buttons
    let testsButton = addButton("testSum", testsColor);
    let confirmedButton = addButton("positiveTests", positiveColor);
    let cpButton = addButton("averageCp", averageCpColor);
    let ageButton = addButton("averageAge", averageAgeColor);

    let buttons = {
      tests: testsButton,
      confirmed: confirmedButton,
      cp: cpButton,
      age: ageButton
    };

    // add button
    function addButton(name, color) {
      let button = buttonsContainer.createChild(am4core.Button);
      button.label.valign = "middle";
      button.label.fill = am4core.color("#000000");
      button.label.fontSize = "11px";
      button.background.cornerRadius(30, 30, 30, 30);
      button.background.strokeOpacity = 0.3;
      button.background.fillOpacity = 0;
      button.background.stroke = buttonStrokeColor;
      button.background.padding(2, 3, 2, 3);
      button.states.create("active");
      button.setStateOnChildren = true;
      button.label.text = capitalizeFirstLetter(name);

      let activeHoverState = button.background.states.create("hoverActive");
      activeHoverState.properties.fillOpacity = 0;

      let circle = new am4core.Circle();
      circle.radius = 8;
      circle.fillOpacity = 0.3;
      circle.fill = buttonStrokeColor;
      circle.strokeOpacity = 0;
      circle.valign = "middle";
      circle.marginRight = 5;
      button.icon = circle;

      // save name to dummy data for later use
      button.dummyData = name;

      let circleActiveState = circle.states.create("active");
      circleActiveState.properties.fill = color;
      circleActiveState.properties.fillOpacity = 0.8;

      button.events.on("hit", handleButtonClick);

      return button;
    }

    // handle button clikc
    function handleButtonClick(event) {
      // we saved name to dummy data
      changeDataType(event.target.dummyData);
    }

    // change data type (active/confirmed/recovered/deaths)
    function changeDataType(name) {
      currentType = name;
      currentTypeName = name;
      // if (name != "deaths") {
      //   currentTypeName += " cases";
      // }

      // bubbleSeries.mapImages.template.tooltipText =
      //   "[bold]{NAME}: \n" + currentTypeName;

      if (name == "testSum") {
        name = "tests";
      } else if (name == "positiveTests") {
        name = "confirmed";
      } else if (name == "averageCp") {
        name = "cp";
      } else if (name == "averageAge") {
        name = "age";
      }

      // make button active
      let activeButton = buttons[name];
      activeButton.isActive = true;
      // make other buttons inactive
      for (var key in buttons) {
        if (buttons[key] != activeButton) {
          buttons[key].isActive = false;
        }
      }

      // show series

      if (seriesTypeSwitch.isActive) {
        if (currentType.includes("tests")) {
          name = "active";
        }
        if (name == "tests") {
          name = "active";
        }
        let testsSeries = columnSeries[name];
        testsSeries.show();
        // hide other series
        for (var key in columnSeries) {
          if (columnSeries[key] != testsSeries) {
            columnSeries[key].hide();
          }
        }
      } else {
        let testsSeries = series[name];
        testsSeries.show();
        // hide other series
        for (var key in series) {
          if (series[key] != testsSeries) {
            series[key].hide();
          }
        }
      }
    }

    // select a city
    function selectCity(mapPolygon) {
      resetHover();
      polygonSeries.hideTooltip();

      // if the same city is clicked show world
      if (currentPolygon == mapPolygon) {
        currentPolygon.isActive = false;
        currentPolygon = undefined;
        showWorld();
        return;
      }
      // save current polygon
      currentPolygon = mapPolygon;
      //let cityIndex = cityIndexMap[mapPolygon.dataItem.dataContext.NAME];
      currentCity = mapPolygon.dataItem.dataContext.NAME;

      // make others inactive
      polygonSeries.mapPolygons.each(function(polygon) {
        polygon.isActive = false;
      });

      // clear timeout if there is one
      if (cityDataTimeout) {
        clearTimeout(cityDataTimeout);
      }
      // we delay change of data for better performance (so that data is not changed whil zooming)
      cityDataTimeout = setTimeout(function() {
        setCityData(currentCity);
      }, 700); // you can adjust number, 1000 is one second

      updateTotals(currentIndex);
      updateCityName();

      mapPolygon.isActive = true;
      //mapChart.zoomToMapObject(mapPolygon, getZoomLevel(mapPolygon));
    }

    // change line chart data to the selected countries
    function setCityData(currentCity) {
      // instead of setting whole data array, we modify current raw data so that a nice animation would happen     
      for (var i = 0; i < lineChart.data.length; i++) {
        let di = pte_city_timeline[i].list;
        let cityIndex = 0;

        for(let j = 0; j < di.length; j++){
          if(di[j].cityName == currentCity){
            cityIndex = j;
          }
        }

        let cityData = di[cityIndex];
        let dataContext = lineChart.data[i];
        if (cityData) {
          dataContext.testSum = cityData.testSum;
          dataContext.hasSymptonPositive = cityData.hasSymptonPositive;
          dataContext.noSymptonPositive = cityData.noSymptonPositive;
          dataContext.positiveTests =
            cityData.hasSymptonPositive + cityData.noSymptonPositive;
          dataContext.averageCp = cityData.averageCp;
          dataContext.averageAge = cityData.averageAge;
          // dataContext.active =
          //   cityData.confirmed - cityData.recovered - cityData.deaths;
          valueAxis.min = undefined;
          valueAxis.max = undefined;
          // console.log(dataContext.averageAge);
        } else {
          dataContext.testSum = 0;
          dataContext.confirmed = 0;
          dataContext.averageCp = 0;
          dataContext.averageAge = 0;
          valueAxis.min = 0;
          valueAxis.max = 10;
        }
      }

      lineChart.invalidateRawData();
      updateTotals(currentIndex);
      setTimeout(updateSeriesTooltip, 20);
    }

    function updateSeriesTooltip() {
      let position = dateAxis.dateToPosition(currentDate);
      position = dateAxis.toGlobalPosition(position);
      let x = dateAxis.positionToCoordinate(position);

      lineChart.cursor.triggerMove({ x: x, y: 0 }, "soft", true);

      lineChart.series.each(function(series) {
        if (!series.isHidden) {
          series.tooltip.disabled = false;
          series.tooltipDataItem.values.dateX.open = 1597828000000;
          series.showTooltipAtDataItem(series.tooltipDataItem);
        }
      });
    }

    // what happens when a city is rolled-over
    function rollOverCity(mapPolygon) {
      resetHover();
      if (mapPolygon) {
        lastHoverColor = mapPolygon.fill;
        lastHoverPolygon = mapPolygon;

        mapPolygon.isHover = true;
        let list = pte_city_timeline[dateIndex].list;

        let value = "0";

        for(let i = 0;  i < list.length; i++){
          if(list[i].cityName == mapPolygon.dataItem.dataContext.NAME){
            value = list[i].noSymptonPositive + list[i].hasSymptonPositive;
          }
        }        
        let printValue = mapPolygon.dataItem.dataContext.NAME + ": " + value;
        mapPolygon.tooltipText = "[Bold]" + printValue;
      }
    }

    // what happens when a city is rolled-out
    function rollOutCity(mapPolygon) {
      if (mapPolygon) {
        resetHover();
        lastHoverPolygon = null;
        mapPolygon.fill = lastHoverColor;
      }
    }

    // rotate and zoom
    function rotateAndZoom(mapPolygon) {
      polygonSeries.hideTooltip();
      let animation = mapChart.animate(
        [
          { property: "deltaLongitude", to: -mapPolygon.visualLongitude },
          { property: "deltaLatitude", to: -mapPolygon.visualLatitude }
        ],
        1000
      );
      animation.events.on("animationended", function() {
        mapChart.zoomToMapObject(mapPolygon, getZoomLevel(mapPolygon));
      });
    }

    // calculate zoom level (default is too close)
    function getZoomLevel(mapPolygon) {
      let w = mapPolygon.polygon.bbox.width / 1;
      let h = mapPolygon.polygon.bbox.width / 1;
      // change 2 to smaller walue for a more close zoom
      return Math.min(
        mapChart.seriesWidth / (w * 4),
        mapChart.seriesHeight / (h * 4)
      );
    }

    // show world data
    function showWorld() {
      currentCity = "Southern Transdanubia";
      currentPolygon = undefined;
      resetHover();

      if (cityDataTimeout) {
        clearTimeout(cityDataTimeout);
      }

      // make all inactive
      polygonSeries.mapPolygons.each(function(polygon) {
        polygon.isActive = false;
      });

      updateCityName();

      // update line chart data (again, modifying instead of setting new data for a nice animation)
      for (var i = 0; i < lineChart.data.length; i++) {
        let di = total_timeline_sum[i];
        let dataContext = lineChart.data[i];

        dataContext.testSum = di.testSum;
        dataContext.positiveTests = di.positiveTests;
        dataContext.averageCp = di.averageCp;
        dataContext.averageAge = di.averageAge;
        dataContext.noSymptonPositive = di.noSymptonPositive;
        dataContext.hasSymptonPositive = di.hasSymptonPositive;
        valueAxis.min = undefined;
        valueAxis.max = undefined;
      }

      lineChart.invalidateRawData();

      updateTotals(currentIndex);
      mapChart.goHome();
    }

    // updates city name and date
    function updateCityName() {
      cityName.text =
        currentCity +
        ", " +
        mapChart.dateFormatter.format(currentDate, "yyyy MMM dd");
    }

    // update total values in buttons
    function updateTotals(index) {
      if (!isNaN(index)) {
        let di = pte_total_timeline[index];
        let dateParse = di.date.split(" ");
        //dateParse[0] = "2020";
        dateParse[1] = dateParse[1][0] + dateParse[1][1];
        dateParse[2] = dateParse[2][0] + dateParse[2][1];
        let stringDate = dateParse[1] + "/" + dateParse[2] + "/" + dateParse[0];
        let date = new Date(stringDate);
        currentDate = date;

        updateCityName();

        let position = dateAxis.dateToPosition(date);
        position = dateAxis.toGlobalPosition(position);
        let x = dateAxis.positionToCoordinate(position);

        if (lineChart.cursor) {
          lineChart.cursor.triggerMove({ x: x, y: 0 }, "soft", true);
        }
        currentIndex = index;
      }
    }

    // update map data
    function updateMapData(data) {
      let counter = 0;
      //modifying instead of setting new data for a nice animation

      maxPC = {
        testSum: 0,
        positiveTests: 0,
        averageCp: 0,
        averageAge: 0,
        hasSymptonPositive: 0,
        noSymptonPositive: 0
      };
      for (let i = 0; i < polygonSeries.mapPolygons.values.length; i++) {
        if (
          polygonSeries.mapPolygons.values[i].dataItem.dataContext.NAME ==
          undefined
        ) {
          polygonSeries.mapPolygons.values.splice(i, 1);
        }
      }

      let mapKeyObj = {};

      for (let i = 0; i < polygonSeries.mapPolygons.values.length; i++) {
        let settlementName =
          polygonSeries.mapPolygons.values[i].dataItem.dataContext.NAME;
        mapKeyObj[settlementName] = i;
      }

      for (var i = 0; i < data.length; i++) {
        let di = data[i];
        let processData = true;

        let polygon = null;
        let cityName = "";

        if (polygonSeries.mapPolygons.length <= 170) {
          polygonSeries.mapPolygons.values.forEach(element => {
            if (element.dataItem.dataContext.cityName == di.cityName) {
              polygon = element;
              cityName = di.cityName;
            }
            counter++;
          });
        } else {
          let polygonIndex = mapKeyObj[di.cityName];
          polygon = polygonSeries.mapPolygons.values[polygonIndex];
          cityName = di.cityName;
        }

        if (processData) {
          if (polygon) {
            var population = Number(populations[cityName]);

            polygon.dataItem.dataContext.testSumPC =
              (di.testSum / population) * 100000;

            polygon.dataItem.dataContext.positiveTestsPC =
              ((di.noSymptonPositive + di.hasSymptonPositive) / population) *
              100000;
            polygon.dataItem.dataContext.averageCpPC = di.averageCp;
            polygon.dataItem.dataContext.averageAgePC = di.averageAge;

            if (population >= 1500) {
              if (polygonSeries.mapPolygons.length > 165) {
                if (
                  polygon.dataItem.dataContext.positiveTestsPC >
                    maxCasesOver.level1 &&
                  polygon.dataItem.dataContext.positiveTestsPC <=
                    maxCasesOver.level2
                ) {
                  polygon.fill = colorRedOne;
                } else if (
                  polygon.dataItem.dataContext.positiveTestsPC >
                    maxCasesOver.level2 &&
                  polygon.dataItem.dataContext.positiveTestsPC <=
                    maxCasesOver.level3
                ) {
                  polygon.fill = colorRedTwo;
                } else if (
                  polygon.dataItem.dataContext.positiveTestsPC >
                    maxCasesOver.level3 &&
                  polygon.dataItem.dataContext.positiveTestsPC <=
                    maxCasesOver.level4
                ) {
                  polygon.fill = colorRedThree;
                } else if (
                  polygon.dataItem.dataContext.positiveTestsPC >
                    maxCasesOver.level4 &&
                  polygon.dataItem.dataContext.positiveTestsPC <=
                    maxCasesOver.level5
                ) {
                  polygon.fill = colorRedFour;
                } else if (
                  polygon.dataItem.dataContext.positiveTestsPC >
                  maxCasesOver.level5
                ) {
                  polygon.fill = colorRedFive;
                } else {
                  polygon.fill = safeColor;
                }

                // if (polygon.dataItem.dataContext.positiveTestsPC > 100) {
                //   polygon.fill = dangerColor;
                // } else if (polygon.dataItem.dataContext.positiveTestsPC > 10) {
                //   polygon.fill = warningColor;
                // } else {
                //   polygon.fill = safeColor;
                // }
              }
            } else {
              if (polygonSeries.mapPolygons.length > 165) {
                if (
                  polygon.dataItem.dataContext.positiveTestsPC >
                    maxCasesUnder.level1 &&
                  polygon.dataItem.dataContext.positiveTestsPC <=
                    maxCasesUnder.level2
                ) {
                  polygon.fill = colorRedOne;
                } else if (
                  polygon.dataItem.dataContext.positiveTestsPC >
                    maxCasesUnder.level2 &&
                  polygon.dataItem.dataContext.positiveTestsPC <=
                    maxCasesUnder.level3
                ) {
                  polygon.fill = colorRedTwo;
                } else if (
                  polygon.dataItem.dataContext.positiveTestsPC >
                    maxCasesUnder.level3 &&
                  polygon.dataItem.dataContext.positiveTestsPC <=
                    maxCasesUnder.level4
                ) {
                  polygon.fill = colorRedThree;
                } else if (
                  polygon.dataItem.dataContext.positiveTestsPC >
                    maxCasesUnder.level4 &&
                  polygon.dataItem.dataContext.positiveTestsPC <=
                    maxCasesUnder.level5
                ) {
                  polygon.fill = colorRedFour;
                } else if (
                  polygon.dataItem.dataContext.positiveTestsPC >
                  maxCasesUnder.level5
                ) {
                  polygon.fill = colorRedFive;
                } else {
                  polygon.fill = safeColor;
                }
              }
            }

            if (lastHoverPolygon != null) {
              if (
                polygon.dataItem.dataContext.NAME ==
                lastHoverPolygon.dataItem.dataContext.NAME
              ) {
                let printValue =
                  lastHoverPolygon.dataItem.dataContext.NAME +
                  ": " +
                  Math.round(di.noSymptonPositive + di.hasSymptonPositive);
                lastHoverPolygon.tooltipText = "[Bold]" + printValue;
              }
            }
          }
        }
        bubbleSeries.invalidateRawData();
        polygonSeries.invalidateRawData();
      }
    }

    // capitalize first letter
    function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }

    function handleImageOver(event) {
      rollOverCity(polygonSeries.getPolygonById(event.target.dataItem.id));
    }

    function handleImageOut(event) {
      rollOutCity(polygonSeries.getPolygonById(event.target.dataItem.id));
    }

    function handleImageHit(event) {
      selectCity(polygonSeries.getPolygonById(event.target.dataItem.id));
    }

    function handleCityHit(event) {
      selectCity(event.target);
    }

    function handleCityOver(event) {
      rollOverCity(event.target);
    }

    function handleCityOut(event) {
      rollOutCity(event.target);
    }

    function handleVirusColor(event) {}

    function resetHover() {
      polygonSeries.mapPolygons.each(function(polygon) {
        polygon.isHover = false;
      });
    }

    container.events.on("layoutvalidated", function() {
      dateAxis.tooltip.hide();
      lineChart.cursor.hide();
      updateTotals(currentIndex);
    });

    // set initial data and names
    updateCityName();
    changeDataType("tests");
    //populateCountries(slideData.list);

    setTimeout(updateSeriesTooltip, 20);

    function updateCityTooltip() {
      polygonSeries.mapPolygons.template.tooltipText =
        "{NAME}:\n[font-size:10px]" + currentTypeName + " per million";
    }
  }, 500);

  function removeAntarctica(mapData) {
    for (var i = mapData.length - 1; i >= 0; i--) {
      if (mapData[i].id == "AQ") {
        mapData.splice(i, 1);
      }
    }
  }
});

export default {
  data() {
    return {
      isHoverable: true,
      isPaginationSimple: false,
      isPaginationRounded: false,
      paginationPosition: "bottom",
      defaultSortDirection: "desc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      currentPage: 1,

      isPaginated: true,

      perPage: 20,
      isBordered: true,
      isStriped: true,
      isNarrowed: true,
      tableData: [],
      columns: [
        {
          field: "cityName",
          label: "Settlement",
          searchable: true,
          centered: true
        },
        {
          field: "testSum",
          label: "Test Sum",
          numeric: true,
          centered: true,
          sortable: true
        },
        {
          field: "noSymptonPositive",
          label: "Asymptomatic",
          numeric: true,
          centered: true,
          sortable: true
        },
        {
          field: "hasSymptonPositive",
          label: "Symptomatic",
          numeric: true,
          centered: true,
          sortable: true
        },
        {
          field: "totalPositive",
          label: "Total Positive",
          numeric: true,
          centered: true,
          sortable: true
        }
      ]
    };
  },
  mounted() {
    this.tableData = new Array(656);
    this.tableData[0] = pte_totalData_city[0];
    for (let i = 1; i < pte_totalData_city.length; i++) {
      let tmpObj = {
        cityName: "",
        testSum: 0,
        noSymptonPositive: 0,
        hasSymptonPositive: 0,
        totalPositive: 0
      };
      this.tableData[i] = tmpObj;
      this.tableData[i].cityName = pte_totalData_city[i].cityName;
      this.tableData[i].testSum = pte_totalData_city[i].testSum;
      this.tableData[i].noSymptonPositive =
        pte_totalData_city[i].noSymptonPositive;
      this.tableData[i].hasSymptonPositive =
        pte_totalData_city[i].hasSymptonPositive;
      this.tableData[i].totalPositive = pte_totalData_city[i].totalPositive;
    }
  }
};
</script>
<style>
#chartdiv {
  max-width: 100%;
  height: 100vh;
  background-color: #ffffff;
}
/* .th-wrap div {
  margin: auto;
} */
.pagination-list {
  margin-bottom: 1.25rem !important;
}
.pagination-list li {
  margin-top: 0.25rem !important;
}
.pagination-link is-current {
  margin-top: 0.5rem !important;
}
.content ul {
  list-style: none;
}
.b-table .table {
  width: 80%;
  margin-left: 10%;
  margin-top: 1rem;
}
li .is-current {
  margin-top: 0.25rem;
}

.th-wrap span {
  margin-left: auto !important;
  margin-right: auto !important;
}

.test-table {
  color: #ffffff;
}
</style>
